<div class='configuration-accelerators-tab-2-part'>
	This is configuration-accelerators tab 2
</div>